<template>
  <div v-if="crossSelling.length" class="flex flex-col gap-10 max-md:-mr-4">
    <Swiper
      v-for="item in crossSelling"
      :key="item.crossSelling.name"
      :breakpoints="breakpoints"
      :space-between="20"
      class="relative w-full"
    >
      <div class="absolute top-0 w-full">
        <div class="flex h-20 items-center justify-between p-4 lg:px-8">
          <h2 class="text-base font-bold">
            {{ getTranslatedProperty(item.crossSelling, 'name') }}
          </h2>
          <div class="flex gap-2">
            <SwiperButton
              direction="prev"
              class="flex size-6 items-center justify-center bg-gray-10"
            />
            <SwiperButton
              direction="next"
              class="flex size-6 items-center justify-center bg-gray-10"
            />
          </div>
        </div>
      </div>
      <SwiperSlide v-for="product in item.products" :key="product.id">
        <ShopProductCard
          :product="product"
          :add-to-cart="isSmallerOrEqual('md')"
          class="h-full"
        />
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script setup lang="ts">
import { getTranslatedProperty } from '@shopware/helpers'
import type { Schemas } from '#shopware'
import SwiperButton from '~/components/SwiperButton.vue'

defineProps<{
  crossSelling: Schemas['CrossSellingElementCollection']
}>()

const { isSmallerOrEqual } = useBreakpoints(tailwindBreakpoints)

const breakpoints = {
  320: {
    slidesPerView: 1.25,
  },
  640: {
    slidesPerView: 2.5,
  },
  768: {
    slidesPerView: 3.5,
  },
  1024: {
    slidesPerView: 5.5,
  },
}
</script>

<style scoped lang="postcss">
::v-deep(.swiper-button-next),
::v-deep(.swiper-button-prev) {
  @apply text-black opacity-100;
  &::after {
    @apply text-sm font-bold;
  }
}
::v-deep(.swiper) {
  @apply pt-20;
}
::v-deep(.swiper-wrapper) {
  @apply items-stretch;
}
::v-deep(.swiper-slide) {
  @apply h-auto;
}
</style>
